mutation RemoveUser($id: ID!) {
    removeUser(id: $id) {
        id
    }
}
